import Menu from './core/Menu'
import Access from './core/Access'
import ModuleRes from './core/module-res'
import globalAccess from './core/global-access'
import AccessCtrl from './components/access-ctrl'
import { flatMenuConfig, transMenuAliasToUri } from './utils/assist'

// 获取权限空间名称
function getAccess(vm) {
    var { access = '', parent = null } = vm.$options

    // 优先取自身
    if (access) {
        if (typeof access == 'function') {
            access = access()
        }

        return access
    }

    // 其次取路由
    if (vm.$route) {
        var r = vm.$route

        access = (r && r.meta && r.meta.access) || ''
    }

    return access
}

// 插件-动态路由（权限相关）
const install = function(Vue, options = {}) {
    var { router, store, i18n } = options

    if (!router) {
        throw new Error('必须提供router实例')
    }

    if (!store) {
        throw new Error('必须提供vuex store实例')
    }

    // config
    Object.keys(Menu.options).forEach(k => {
        if (typeof options[k] != 'undefined') {
            Menu.options[k] = options[k]
        }
    })

    Object.keys(Access.options).forEach(k => {
        if (typeof options[k] != 'undefined') {
            Access.options[k] = options[k]
        }
    })

    // router
    router.beforeEach((to, from, next) => {
        // 解析资源菜单
        if (store.state.resource.hasMenu) {
            next()
        } else {
            // 添加动态路由
            store.commit('resource/setMenu', {
                router,
                i18n,
                to,
            })

            next()
        }
    })

    // 动态404页面重定向
    router.beforeEach((to, from, next) => {
        if (to.name == 'error_404') {
            var dyr,
                params,
                tPath = to.path.replace(/\/$/, '') // 统一去除尾部'/'，便于path对比

            // 根路由
            if (to.path == '/') {
                dyr = store.state.resource.flatRoutes.find(
                    v => v.meta.fullPath == '/'
                )
            } else {
                tPath = tPath ? tPath.split('/') : []

                if (tPath.length > 0) {
                    dyr = store.state.resource.flatRoutes.find(v => {
                        var sPath = v.meta.fullPath.replace(/$\//, '')

                        params = {}
                        sPath = sPath ? sPath.split('/') : []

                        // 遍历part比较
                        return (
                            sPath.length == tPath.length &&
                            tPath.every((t, i) => {
                                if (t === sPath[i]) {
                                    return true
                                }

                                // 提取动态参数值
                                if (
                                    sPath[i] &&
                                    t &&
                                    sPath[i].indexOf(':') == 0
                                ) {
                                    params[sPath[i].replace(':', '')] = t

                                    return true
                                }

                                return false
                            })
                        )
                    })
                }
            }

            if (dyr) {
                return next({
                    name: dyr.name || dyr.meta.targetName,
                    params,
                    query: to.query,
                })
            }
        }

        next()
    })

    // store module
    store.registerModule('resource', ModuleRes)

    // $access
    Vue.mixin({
        beforeCreate() {
            var { access = '', parent } = this.$options

            // 为实例注入$access对象
            this.$access = globalAccess

            // 设置access
            if (access) {
                if (typeof access == 'function') {
                    this.$options.access = access.bind(this)
                }
            } else {
                // 默认继承父级access
                if (parent) {
                    this.$options.access = parent.$options.access
                }
            }
        },

        methods: {
            // 动词判断
            $can(verb, alias) {
                return this.$access.can(verb, alias ? alias : getAccess(this))
            },

            // uri判断
            $have(uri, scope) {
                return this.$access.have(uri, scope)
            },
        },
    })

    // 权限控制组件
    Vue.component('Access', AccessCtrl)

    // 全局注入
    Vue.$access = globalAccess
}

export default install

export { Menu, globalAccess as access, flatMenuConfig, transMenuAliasToUri }
